module.exports = __webpack_public_path__ + "vfn-assets/img/img-pasos-iniciasesion-icono.1a0e06bc.svg";